import MgrBase from "./mrg-base";
import { isPermissionDenied, isPermissionGranted, safariPermissionFlow } from "../utils/apple";
import { ConfigHelper } from "../helpers/config-helper";
import ApnsApp from "../models/apns-app";

/**
 * token registration and push listener are managed automatically by the system
 * we just need to expose some api
 * @see https://developer.apple.com/library/archive/documentation/NetworkingInternet/Conceptual/NotificationProgrammingGuideForWebsites/PushNotifications/PushNotifications.html
 */
export default class MgrApns extends MgrBase {
    static SERVICE = "webapns2";

    /**
     * check config validation
     * @param {
     *      pushId: String,
     *      webServiceUrl: String
     *  } config
     */
    async init() {
        const config = this._getConfig();
        await ConfigHelper.saveApp(config.getPackageName(), {
            pushId: config.getPushId(),
            webServiceUrl: config.getWebServiceURL()
        });
    }

    /**
     * start permission request flow
     * @returns Promise<String>
     */
    async requestPermission() {
        const config = this._getConfig();
        return safariPermissionFlow(config.getWebServiceURL(), config.getPushId());
    }

    hasPermission() {
        return isPermissionGranted(this._getConfig().getPushId());
    }

    hasNotPermission() {
        return isPermissionDenied(this._getConfig().getPushId());
    }

    _getConfig(): ApnsApp {
        return this._config;
    }

    _getService() {
        return MgrApns.SERVICE;
    }
}
